import environment from "@/api/environment";

const ADMIN_ROUTES = new Set([
  "MainMenu", "Dashboard", "TransactionRoomBooking", "ViewSchedule",
  "Facility", "Location", "Utility", "Zone", "Roompad",
  "ManageUser", "ManageRole", "ManageOrder", "ManageOrderDetail",
  "ReservationCondition",
]);
const apiUrl = new URL(environment.apiUrl);

export function applyAdminRequestTimeout(config, routeName) {
  if (!ADMIN_ROUTES.has(routeName)) return config;

  let requestUrl;
  try {
    requestUrl = new URL(config.url, config.baseURL || environment.apiUrl);
  } catch (error) {
    return config;
  }
  if (requestUrl.origin !== apiUrl.origin || !requestUrl.pathname.startsWith(apiUrl.pathname)) {
    return config;
  }

  const method = (config.method || "get").toLowerCase();
  const action = requestUrl.pathname.split("/").pop();
  const isExport = /^export/i.test(action);
  const readsData = method === "get" || method === "head" || /^(get|export|search|checkToken$)/i.test(action);
  config.adminRequestKind = readsData ? "read" : "write";
  // Preserve explicit deadlines; never resend a timed-out mutation.
  if (!(config.timeout > 0)) config.timeout = readsData && !isExport ? 30000 : 60000;
  return config;
}

export function describeAdminTimeout(error, locale) {
  if (!error.config?.adminRequestKind || !["ECONNABORTED", "ETIMEDOUT"].includes(error.code)) return;
  const isWrite = error.config.adminRequestKind === "write";
  if (locale === "th") {
    error.message = isWrite
      ? "ยังยืนยันผลการบันทึกไม่ได้ เนื่องจากการเชื่อมต่อหมดเวลา กรุณาตรวจสอบรายการก่อนทำซ้ำ"
      : "การโหลดข้อมูลหมดเวลา กรุณาลองใหม่";
  } else {
    error.message = isWrite
      ? "The request timed out before the save could be confirmed. Check the records before trying again."
      : "Loading data timed out. Please try again.";
  }
}
